import { Component, OnInit } from '@angular/core';
import { VerificationResponseData } from '../../../../../models/verification-response-data';
import { DssReports } from '../../../../../models/dss-reports';
import { environment } from '../../../../../../environments/environment';
import { VerificationSession } from '../../../services/verification-session.service';
import { SpinnerService } from '../../../../shared/services/spinner.service';
import { ShowOrHideSpinner } from '../../../../shared/models/showOrHideSpinner';
import { ShowOrHideComponent } from '../../../../shared/models/showOrHideComponent';
import { ReportMessages } from '../../../../shared/models/component-messages/report-messages';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { MomentDatePipe } from '../../../../../models/moment-date.pipe';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeFr, 'fr');

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss']
})
export class ResultComponent extends ShowOrHideSpinner implements OnInit, ShowOrHideComponent {

  public verificationResponseData: VerificationResponseData;
  public windowScrolled = false;
  public dssReports: DssReports;
  public previousDssReports: DssReports;
  public reportFileName: string;
  public previousReportFileName: string;
  public profile = environment.profile;
  public originalFileName: any;
  public reportMessages = new ReportMessages();
  public isNewActive = true;
  public isPreviousReportPresent = false;
  public momentDatePipe: MomentDatePipe;

  constructor(private verificationSession: VerificationSession, private spinnerService: SpinnerService,
              private commonService: CommonService) {
    super();
  }

  public showComponent() {
    return this.isSpinnerNotInProgress(this.spinnerService) && this.update();
  }

  public activeTab(state: boolean) {
    this.isNewActive = state;
    if (!this.isNewActive && document.getElementById('pills-old-tab')) {
      document.getElementById('pills-new-tab').classList.remove('active');
      document.getElementById('pills-old-tab').classList.add('active');
    } else if (this.isNewActive && document.getElementById('pills-old-tab')) {
      document.getElementById('pills-new-tab').classList.add('active');
      document.getElementById('pills-old-tab').classList.remove('active');
    }
  }

  public ngOnInit() {
    this.momentDatePipe = new MomentDatePipe('fr');
    this.update();
  }

  public update() {
    this.hideSpinner(this.spinnerService);
    if (this.isResponsePresent()) {
      this.originalFileName = this.verificationSession.verificationRequestData.originalFile;
      this.verificationResponseData = this.verificationSession.verificationResponseData;
      this.dssReports = this.verificationSession.verificationResponseData.dssReports;
      if (this.verificationSession.verificationResponseData.previousReport) {
        this.previousDssReports = this.verificationSession.verificationResponseData.previousDssReports;
        this.isPreviousReportPresent = true;


        // add Date To Name
        this.previousReportFileName = this.commonService.getFileNameWithAdditionalParameter(
          this.verificationResponseData.previousReport.xmlReport.information.fileName,
          this.verificationResponseData.previousReport.xmlReport.information.verificationDate
        );

        // add reportId to Name
        this.previousReportFileName = this.commonService.getFileNameWithAdditionalParameter(
          this.previousReportFileName,
          this.verificationResponseData.previousReport.reportId
        );

      } else {
        this.isPreviousReportPresent = false;
      }

      // add Date To Name
      this.reportFileName = this.commonService.getFileNameWithAdditionalParameter(
        this.verificationResponseData.newReport.xmlReport.information.fileName,
        this.verificationResponseData.newReport.xmlReport.information.verificationDate
      );
      // add reportId to Name
      this.reportFileName = this.commonService.getFileNameWithAdditionalParameter(
        this.reportFileName,
        this.verificationResponseData.newReport.reportId
      );

      return true;
    }
    return false;
  }

  private isResponsePresent(): boolean {
    if (this.verificationSession.verificationResponseData) {
      if (this.verificationSession.verificationResponseData.newReport) {
        return true;
      }
    }
    return false;
  }
}
